<template>
  <div id="app">
    <header class="mv">
      <div class="wrapper">
        <h1>
          <img src="./assets/mv.png" alt="2025 mozoの福袋　1.1元旦 AM9:00 START!! これ以上ないお得感、今しか手に入らない福袋！" class="pc">
          <img src="./assets/mv_sp.png" alt="2025 mozoの福袋　1.1元旦 AM9:00 START!! これ以上ないお得感、今しか手に入らない福袋！" class="sp">
        </h1>
        <img src="./assets/mv_content.png" alt="予約福袋について　対象店舗にて予約販売をしております。" class="content">
      </div>
    </header>
    <main>
      <section class="filter">
				<!-- <p class="bnrMozoplus"><a href="https://plus.mozo-wondercity.com/all/svc/product/Search/?genre_id1=39&genre_id=3901" target="_blank" rel="noopener noreferrer" @click="mozoplusBnr"><img src="./assets/bnr_mozoplus.jpg" alt="2022 福袋　オンラインショップ mozoPLUS限定　2021 12/29（水） → 2022 1/10（月・祝）まで開催！　詳しくはこちら"></a></p> -->

        <div class="wrapper">
          <h2>
            条件で絞り込み
          </h2>
          <dl class="form">
            <dt class="name">
              発売日
            </dt>
            <dd>
              <checkBtn
              v-for="(date, i) in form.date"
              :key="i"
              v-model="form.date[i].value"
              >{{date.title}}</checkBtn>
            </dd>
            <dt class="name">
              事前予約
            </dt>
            <dd>
              <checkBtn
              v-for="(res, i) in form.res"
              :key="i"
              v-model="form.res[i].value"
              >{{res.title}}</checkBtn>
            </dd>
            <dt class="name">
              カテゴリー
            </dt>
            <dd>
              <checkBtn
              v-for="(cat, i) in form.cat"
              :key="i"
              v-model="form.cat[i].value"
              small
              >{{cat.title}}</checkBtn>
            </dd>
            <dt class="name">
              ショップ名称
            </dt>
            <dd>
              <checkBtn
              v-for="(name, i) in form.name"
              :key="i"
              v-model="form.name[i].value"
              small
              >{{name.title}}</checkBtn>
            </dd>
          </dl>
          <div class="apply">
            <btn active @click="applyFilter" wider>
              <img src="./assets/search.png" class="prepend">検索する
            </btn>
            <span class="clear" @click="clearFilter">
              <img src="./assets/clear.png" alt="">
              条件クリア
            </span>
          </div>
          <div class="banner">
            <a href="https://www.mozo-wondercity.com/mozo-s/pdf/floorguide.pdf" target="_blank" rel="noopener noreferrer" @click="mapmarkBnr">
              <img src="./assets/mapmark.png" alt="各店へのアクセスは、下記アイコンの出入口からがとっても便利です。[A][B][B1][B2][C][E][F][G][H][K] ※入口の場所はこちらをご覧ください" class="pc">
              <img src="./assets/mapmark_sp.png" alt="各店へのアクセスは、下記アイコンの出入口からがとっても便利です。[A][B][B1][B2][C][E][F][G][H][K] ※入口の場所はこちらをご覧ください" class="sp">
            </a>
          </div>
        </div>
      </section>
      <section class="list" ref="list">
        <div class="wrapper">
          <template
          v-for="(list,key) in sorted"
          >
            <itemList
            :key="key"
            :data="list"
            :day="key"
            top
            />
          </template>
        </div>
      </section>
      <transition name="slideIn">
        <router-view
        :data="sorted"
        @scroll="scroll"
        />
      </transition>
      <section class="notice">
        <div class="wrapper">
          <p>
            ※画像はイメージです。 ※広告掲載の価格は総額表記（税込価格）です。<br>
            ※掲載の内容につきましては、表記の各店舗に直接お問合せください。<br>
            ※各店予約数に限りがございます。<br>
            ※広告の品は多数ご用意しておりますが、品切れの節はご容赦ください。<br>
            ※閲覧環境によって、現物と色が異なる場合がございます。<br>
            ※1/1（元日）は福袋が完売するまで、他の商品の販売を中止する店舗がございます。<br>
            ※福袋は数量限定にて販売いたしますので、完売の場合はご容赦ください。<br>
            ※掲載内容は予告なく変更する場合がございます。あらかじめご了承ください。<br>
            ※掲載情報は2024年12月9日（月）現在のものです。
          </p>
        </div>
      </section>
    </main>
    <transition name="slideUp">
      <div class="bottomBar" v-if="!scrolling">
        <a href="/lp/2025/fukubukuro/assets/pdf/map.pdf" target="_blank" @click="bottomBnr">
          <img src="./assets/bottom.png" alt="『特設会場』『整理券優先入口店舗』『優先入口実施店舗』のご案内はこちら" class="pc">
          <img src="./assets/bottom_sp.png" alt="『特設会場』『整理券優先入口店舗』『優先入口実施店舗』のご案内はこちら" class="sp">
        </a>
      </div>
    </transition>
    <footer>
      <ul class="links">
        <li>
          <a
          href="https://www.facebook.com/Mozo-wondercity-164641164108183/"
          target="_blank"
          rel="noopener noreferrer"
          >
            <img src="./assets/fb.png" alt="facebook">
          </a>
        </li>
        <li>
          <a
          href="https://line.me/R/ti/p/%40znr2267g"
          target="_blank"
          rel="noopener noreferrer"
          >
            <img src="./assets/line.png" alt="line">
          </a>
        </li>
        <li>
          <a
          href="http://twitter.com/share?url=https://www.mozo-wondercity.com/lp/2024/fukubukuro/&text=mozo 2025 福袋"
          target="_blank"
          rel="noopener noreferrer"
          >
            <img src="./assets/x.png" alt="X">
          </a>
        </li>
      </ul>
      <div class="logo">
        <a href="https://www.mozo-wondercity.com/">
          <img src="./assets/logo.png" alt="mozo WONDER CITY">
        </a>
      </div>
      <div class="copy">
        &copy; mozo wonder city all rights reserved.
      </div>
      <a v-smooth-scroll href="#app" class="toTop">
        <img src="./assets/totop.png" alt="PAGE TOP">
      </a>
    </footer>
  </div>
</template>

<script>
import checkBtn from './components/checkBtn'
import itemList from './components/itemList'
import btn from './components/btn'

export default {
  components: {
    checkBtn,
    itemList,
    btn,
  },
  created(){
    this.init()
    window.addEventListener('scroll', this.scroll)
  },
  methods: {
    async init() {
      let res = (await this.$axios.get('./assets/json/data.json')).data
      this.list.data = res
      this.filtered = res
      this.list.loaded = true
    },
    scroll(){
      this.scrolling = true
      clearTimeout(this.timer)
      this.timer = setTimeout(()=>{
        this.scrolling = false
      }, 500)
    },
    applyFilter(){
      let result = this.list.data.filter(item=>{
        let r = false
        let rl = []
        Object.keys(this.form).forEach(key=>{ // 日付・予約・カテゴリー・名称
          let filters = this.form[key]
          let rl2 = []
          filters.forEach((filter,i)=>{
            let r2 = false
            if (filter.value) {
              if(filter.key=='all') r2 = true
              if(filter.key!='all') r2 = filter.reverse
              ? !Boolean(item[filter.key])
              : Boolean(item[filter.key])
            }
            rl2.push(r2)
          })
          if (filters.find(f=>f.value)) {
            rl.push(rl2.indexOf(true)!=-1)
          }else{
            rl.push(true)
          }
        })
        return rl.indexOf(false)==-1
      })

			//gaタグ
			let sendtxtArry = []
			Object.keys(this.form).forEach(key=>{
				let formArry = this.form[key]

				formArry.forEach((filter,i)=>{
					let booleanTxt = filter.value

					if(booleanTxt === true) {
						sendtxtArry.push(filter.title)
					}else if(booleanTxt === false) {
						sendtxtArry.push('')
					}
				})
			})
			let sendtxt = sendtxtArry.join(',')
			//console.log(sendtxt)
			window.ga('send', 'event', '【福袋2022】', 'search', sendtxt);

      this.filtered =  result
      this.$smoothScroll({
        scrollTo: this.$refs.list,
      })
    },
		mozoplusBnr(){
			window.ga('send', 'event', '【福袋2022】', 'click', 'PLUSバナー');
		},
    mapmarkBnr(){
      window.ga('send', 'event', '【福袋2022】', 'click', 'floorguide');
    },
		bottomBnr(){
			window.ga('send', 'event', '【福袋2022】', 'click', 'footer');
		},
    clearFilter(){
      Object.keys(this.form).forEach(key=>{
        let filters = this.form[key]
        filters.map(filter=>{
          filter.value = false
        })
      })
      this.filtered = this.list.data
    },
  },
  computed: {
    sorted(){
      let result = {
        'day-1': [],
        'day-2': [],
        'day-3': [],
      }
      this.filtered.forEach(item=>{
        Object.keys(result).forEach(day=>{
          if (Boolean(item[day])) result[day].push(item)
        })
      })
      return result
    },
  },
  data: function(){
    return {
      scrolling: false,
      timer: null,
      list: {
        loaded: false,
        data: [],
      },
      filtered: [],
      form: {
        date: [
          {
            title: '1月1日（水・祝）',
            value: false,
            key: 'day-1',
          },
          {
            title: '年内販売',
            value: false,
            key: 'day-2',
          },
          {
            title: '日付指定なし',
            value: false,
            key: 'all',
          },
        ],
        res: [
          {
            title: '事前予約あり',
            value: false,
            key: 'reservation-1'
          },
          {
            title: '事前予約なし',
            value: false,
            key: 'reservation-1',
            reverse: true,
          },
        ],
        cat: [
          {
            title: 'ファッション',
            value: false,
            key: 'category-A'
          },
          {
            title: 'ライフスタイルアイテム',
            value: false,
            key: 'category-B'
          },
          {
            title: 'グルメ',
            value: false,
            key: 'category-C'
          },
          {
            title: 'サービス',
            value: false,
            key: 'category-D'
          },
        ],
        name: [
          {
            title: 'ア',
            value: false,
            key: 'shop-A'
          },
          {
            title: 'カ',
            value: false,
            key: 'shop-KA'
          },
          {
            title: 'サ',
            value: false,
            key: 'shop-SA'
          },
          {
            title: 'タ',
            value: false,
            key: 'shop-TA'
          },
          {
            title: 'ナ',
            value: false,
            key: 'shop-NA'
          },
          {
            title: 'ハ',
            value: false,
            key: 'shop-HA'
          },
          {
            title: 'マ',
            value: false,
            key: 'shop-MA'
          },
          {
            title: 'ヤ',
            value: false,
            key: 'shop-YA'
          },
          {
            title: 'ラ',
            value: false,
            key: 'shop-RA'
          },
          {
            title: 'ワ',
            value: false,
            key: 'shop-WA'
          },
        ]
      }
    }
  }
}
</script>

<style lang="scss">
@import './assets/css/reset.css';
@import './assets/css/common.scss';

body {
  background: url('./assets/bg.png') left top repeat;
}
.mv {
  padding: 1rem 0 10rem;
  @include SP {
    padding: 1rem 0 8rem;
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  h1 + img {
    width: 72rem;
    @include SP {
      width: 67rem;
    }
  }
  }
.filter {
  padding: 10rem 0;
  background: #fff8ee;
  @include SP {
    padding-left: 3rem;
    padding-right: 3rem;
  }
	.bnrMozoplus {
		margin: 0 auto 10rem;
		width: 76rem;
		@include SP {
			width: 67rem;
		}
	}
  h2 {
    font-size: 2.6rem;
    text-align: center;
    @include SP {
      font-size: 3.8rem;
    }
    &::after {
      content: "";
      display: block;
      width: 22rem;
      height: 2.1rem;
      margin: 1.6rem auto 0;
      background: url('./assets/filter_h2_after.png') center top / contain no-repeat;
      @include SP {
        width: 33rem;
        height: 3rem;
      }
    }
  }
  .form {
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
    padding: 3.6rem 0 2.5rem;
    dt {
      width: 18.5rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 1.5em 2.4rem;
      font-weight: bold;
      @include SP {
        font-size: 3rem;
        padding-left: 0;
        justify-content: flex-start;
        width: 100%;
      }
    }
    dd {
      width: calc(100% - 18.5rem);
      @include SP {
        width: 100%;
        margin-bottom: 4rem;
      }
    }
  }
  .apply {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8rem;
    @include SP {
      flex-direction: column;
    }
    .clear {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-left: 3.6rem;
      text-decoration: underline;
      cursor: pointer;
      @include SP {
        margin: 6rem 0 0;
        font-size: 3rem;
      }
      img {
        width: 2rem;
        margin-right: .4em;
        @include SP {
          width: 3.6rem;
        }
      }
    }
  }
  .banner {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.list {
  padding: 13rem 0 0;
  @include SP {
    paddign: 11.5rem 0 0;
  }
}
.notice {
  padding: 3.6rem 0 7.2rem;
  @include SP {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  p {
    line-height: 1.8;
    @include SP {
      font-size: 2.6rem;
    }
  }
}
.bottomBar {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 10.5rem;
  background: #004f78;
  color: #fff;
  @include SP {
    height: 15rem;
    padding: 0 2.4rem;
  }
  .sub {
    margin-top: .8em;
    @include SP {
      font-size: 2rem;
      line-height: 1.3;
    }
  }
}
.slideUp-enter-active,
.slideUp-leave-active {
  transition: .3s;
}
.slideUp-enter,
.slideUp-leave-to {
  transform: translateY(100%);
}
.slideIn-enter-active,
.slideIn-leave-active {
  transition: .18s;
}
.slideIn-enter, .slideIn-leave-to {
  transform: translateX(100%);
}
footer {
  position: relative;
  margin-bottom: 16rem;
  text-align: center;
  @include SP {
    margin-bottom: 20rem;
  }
  .links {
    margin-bottom: 1.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    li {
      flex-shrink: 0;
      img {
        flex-shrink: 0;
        width: 7.8rem;
        @include SP {
          width: 10rem;
        }
      }
      &+li {
        margin-left: 5rem;
        @include SP {
          margin-left: 6.4rem;
        }
      }
    }
  }
  .logo {
    margin-bottom: 2.4rem;
    img {
      width: 16rem;
      @include SP {
        width: 23rem;
      }
    }
  }
  .copy {
    @include SP {
      font-size: 2.2rem;
    }
  }
  .toTop {
    position: absolute;
    bottom: -2rem;
    right: 5.2rem;
    display: block;
    width: 11.1rem;
    @include SP {
      right: 1rem;
    }
    img {
      width: 100%;
    }
  }
}
</style>
